import { PATH } from '@constants';
import React from 'react';
import { Navigate } from 'react-router-dom';

function MainPage() {
  return <Navigate to={PATH.cursos} replace />;
}

export default MainPage;
